import React from 'react';
import useLoyaltyStore from './useLoyaltyStore';
import PartnerFormModal from './PartnerFormModal';

const PartnersTab = () => {
  const {
    partners,
    partnersLoading,
    openModal,
    closeModal,
    modalOpen,
    modalType,
    deletePartner,
  } = useLoyaltyStore();

  const handleEdit = (partner) => {
    openModal('partner', 'edit', partner);
  };

  const handleDelete = (partner) => {
    if (window.confirm(`Are you sure you want to delete "${partner.name}"?`)) {
      deletePartner(partner.id);
    }
  };

  const handleAdd = () => {
    openModal('partner', 'create');
  };

  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : '?';
  };

  const getTypeBadge = (type) => {
    if (type === 'internal') {
      return <span className="badge badge-info">Internal Hermina</span>;
    }
    return <span className="badge badge-success">External Partner</span>;
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Partners</h5>
        <button className="btn btn-primary btn-sm" onClick={handleAdd}>
          + Add Partner
        </button>
      </div>

      {partnersLoading ? (
        <div className="text-center py-4">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Logo</th>
              <th>Partner Name</th>
              <th>Type</th>
              <th>Active Rewards</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {partners.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-muted py-4">
                  No partners found. Add your first partner.
                </td>
              </tr>
            ) : (
              partners.map((partner) => (
                <tr key={partner.id}>
                  <td>
                    {partner.logo_url ? (
                      <img
                        src={partner.logo_url}
                        alt={partner.name}
                        style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: '50%',
                          backgroundColor: '#28a745',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                        }}
                      >
                        {getInitial(partner.name)}
                      </div>
                    )}
                  </td>
                  <td className="align-middle">{partner.name}</td>
                  <td className="align-middle">{getTypeBadge(partner.partner_type)}</td>
                  <td className="align-middle">{partner.active_rewards_count ?? 0}</td>
                  <td className="align-middle">
                    <button
                      className="btn btn-sm btn-outline-secondary mr-1"
                      onClick={() => handleEdit(partner)}
                      title="Edit"
                    >
                      <i className="zmdi zmdi-edit" />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(partner)}
                      title="Delete"
                    >
                      <i className="zmdi zmdi-delete" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {modalOpen && modalType === 'partner' && (
        <PartnerFormModal />
      )}
    </div>
  );
};

export default PartnersTab;
